// Components
import React, { useEffect, useState } from 'react';

import ExternalLink from '@/common/components/atoms/ExternalLink/ExternalLink';
import Picture from '@/common/components/atoms/Picture/Picture';
import Video from '@/common/components/atoms/Video/Video';
import formatSrcSet from '@/common/helpers/formatSrcSet';
import getImageBySize from '@/common/helpers/getImageBySize';
// Hooks
import usePromotionBlock from '@/common/hooks/promotion-block/usePromotionBlock';

import {
  PromotionBlockDefaultProps,
  PromotionBlockPropTypes,
} from './PromotionBlock.proptypes';

const PromotionBlock = ({ formats }) => {
  const [promotion, setPromotion] = useState(null);

  const { data: promotionBlock, isSuccess } = usePromotionBlock({
    type: 'insert',
    position: 'home',
    limit: 10,
  });

  useEffect(() => {
    if (isSuccess && promotionBlock.data && promotionBlock.data.length > 0) {
      const randomItem = Math.floor(Math.random() * promotionBlock.data.length);
      setPromotion(promotionBlock.data[randomItem]);
    }
  }, [isSuccess, promotionBlock]);

  return (
    <div className="page-home__promotion-block" data-qa-id="promotion-block">
      {promotion && (
        <>
          {promotion.link_video ? (
            <Video
              className="promotion-block promotion-block--video"
              src={promotion.link_video}
              title={promotion.title}
            />
          ) : (
            <ExternalLink
              href={promotion.link}
              className="promotion-block promotion-block--image"
              context="promotion-block-image"
            >
              {promotion?.images?.length > 0 && (
                <Picture
                  alt={promotion.images[0].alt}
                  src={getImageBySize(
                    promotion.images[0].url,
                    formats[promotion.images[0].destination],
                  )}
                  srcSet={formatSrcSet(promotion.images, formats)}
                  type="static"
                />
              )}
            </ExternalLink>
          )}
        </>
      )}
    </div>
  );
};

PromotionBlock.defaultProps = {
  ...PromotionBlockDefaultProps,
};

PromotionBlock.propTypes = {
  ...PromotionBlockPropTypes,
};

export default PromotionBlock;
